export default __webpack_public_path__ + "static/media/dial_widget.a3f579bd.png";